import React, { Component } from "react";
import ItemMasterServices from "../../services/axioServices/apiServices/ItemMasterServices.js";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import ValidationText from "../../utils/validation/ValidationText.js";
import { CommonValidationMessages } from "../../utils/Messages.js";
import { isValidForm } from "../../utils/validation/CommonValidator.js";
import SwalServices from "../../services/swalServices/SwalServices.js";

class HSNCodes extends Component {
  constructor(props) {
    super(props);
    this.itemMasterServices = new ItemMasterServices();
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.state = {
      _id: "",
      isEditing: false,
      isLoading: false,
      hNSCodesListing: [],
      tableStatus: "",
      hNSCodeDetails: {
        HSNCode: "",
        HNSCodeDescription: "",
        SGST: "",
        CGST: "",
        IGST: "",
        UTGST: "",
      },
      validationRule: {
        HSNCode: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "HSN code"
            ),
          },
        ],
        HNSCodeDescription: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "HSN code description"
            ),
          },
        ],
        SGST: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "SGST"
            ),
          },
        ],
        CGST: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "CGST"
            ),
          },
        ],
        IGST: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "IGST"
            ),
          },
        ],
        UTGST: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "UTGST"
            ),
          },
        ],
      },
      validState: {
        isValid: true,
        error: {},
      },
    };
  }

  componentDidMount() {
    this.getAllHSNCode();
  }

  getAllHSNCode = () => {
    this.setState({ tableStatus: "Loading..." })
    this.commonServices.getAllHSNCode().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        if (response.responseData.length === 0) {
          this.setState({ tableStatus: "No Record Found" })
        } else {
          this.setState({ tableStatus: "" })
        }
        this.setState(
          { hNSCodesListing: response.responseData });
      } else {
        this.setState({ tableStatus: "" })
        this.SwalServices.Error(response.Message);
      }
    });
  };

  addEditHSNCode = () => {
    let isValidAllFields = this.isValidAllFields();
    if (isValidAllFields) {
      this.setState({ isLoading: true }, () => {
        let request = this.state.hNSCodeDetails;
        if (this.state._id && this.state._id !== "") {
          request._id = this.state._id;
        } else {
          delete request._id;
        }
        this.itemMasterServices.addEditHSNCode(request).then((response) => {
          if (response.statusCode === 200 && response.responseData != null) {
            this.SwalServices.Success(response.Message);
            this.getAllHSNCode();
            this.resetForm();
            this.setState({ isLoading: false });
          } else {
            this.SwalServices.Error(response.Message);
            this.setState({ isLoading: false });
          }
        });
      });
    }
  };

  resetForm = () => {
    let validState = this.state.validState;
    validState.isValid = true;
    validState.error = {};
    let details = this.state.hNSCodeDetails;
    details.HSNCode = "";
    details.HNSCodeDescription = "";
    details.SGST = "";
    details.CGST = "";
    details.IGST = "";
    details.UTGST = "";
    this.setState({ hNSCodeDetails: details, _id: "", isEditing: false, validState: validState, tableStatus: "" });
  };

  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.hNSCodeDetails;
    details[name] = value.toUpperCase();
    this.setState({ hNSCodeDetails: details });
  };

  getHSNCodeId = (group) => {
    let details = this.state.hNSCodeDetails;
    details.HSNCode = group.HSNCode;
    details.HNSCodeDescription = group.HNSCodeDescription;
    details.SGST = group.SGST.toFixed(2);
    details.CGST = group.CGST.toFixed(2);
    details.IGST = group.IGST.toFixed(2);
    details.UTGST = group.UTGST.toFixed(2);
    this.setState({ hNSCodeDetails: details, _id: group._id }, () => {
      this.setState({ isEditing: true });
    });
  };

  deleteHSNCodeById = (id) => {
    this.itemMasterServices.deleteHSNCodeById(id).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.SwalServices.Success(response.Message);
        this.resetForm();
        this.getAllHSNCode();
      } else {
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  isValidAllFields = () => {
    const newValidState = isValidForm(
      this.state.hNSCodeDetails,
      this.state.validationRule,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };

  render() {
    return (
      <div className="hsn-page">
        <div className="item-form">
          <div className="form-table !gap-y-1.25 !gap-x-2.5">
            <div className="item-grp !gap-0">
              <label>HSN Code</label>
              <input
                className={`inputFocus ${this.state.validState?.error?.HSNCode ? "errorInput" : ""}`}
                type="text"
                id="HSNCode"
                name="HSNCode"
                autoComplete="off"
                value={this.state.hNSCodeDetails.HSNCode}
                onChange={(event) => this.handleChange(event, "HSNCode")}
              />
              {/* <ValidationText error={this.state.validState.error.HSNCode} /> */}
            </div>
            <div className="item-grp !gap-0">
              <label>HSN Description</label>
              <input
                className={`inputFocus ${this.state.validState?.error?.HNSCodeDescription ? "errorInput" : ""}`}
                type="text"
                id="HNSCodeDescription"
                name="HNSCodeDescription"
                autoComplete="off"
                value={this.state.hNSCodeDetails.HNSCodeDescription}
                onChange={(event) =>
                  this.handleChange(event, "HNSCodeDescription")
                }
              />
              {/* <ValidationText
                error={this.state.validState.error.HNSCodeDescription}
              /> */}
            </div>
          </div>

          <div className="form-table !flex !gap-2.5 mt-3">
            <div className="item-grp !gap-0 w-full" >
              <label>S.G.S.T [%]</label>
              <input
                className={`inputFocus ${this.state.validState?.error?.SGST ? "errorInput" : ""}`}
                type="number"
                id="SGST"
                name="SGST"
                autoComplete="off"
                value={this.state.hNSCodeDetails.SGST}
                onChange={(event) => this.handleChange(event, "SGST")}
              />
              {/* <ValidationText error={this.state.validState.error.SGST} /> */}
            </div>
            <div className="item-grp !gap-0 w-full">
              <label>C.G.S.T [%]</label>
              <input
                className={`inputFocus ${this.state.validState?.error?.CGST ? "errorInput" : ""}`}
                type="number"
                id="CGST"
                name="CGST"
                autoComplete="off"
                value={this.state.hNSCodeDetails.CGST}
                onChange={(event) => this.handleChange(event, "CGST")}
              />
              {/* <ValidationText error={this.state.validState.error.CGST} /> */}
            </div>
            <div className="item-grp !gap-0 w-full">
              <label>I.G.S.T [%]</label>
              <input
                className={`inputFocus ${this.state.validState?.error?.IGST ? "errorInput" : ""}`}
                type="number"
                id="IGST"
                name="IGST"
                autoComplete="off"
                value={this.state.hNSCodeDetails.IGST}
                onChange={(event) => this.handleChange(event, "IGST")}
              />
              {/* <ValidationText error={this.state.validState.error.IGST} /> */}
            </div>
            <div className="item-grp !gap-0 w-full">
              <label>UT.G.S.T [%]</label>
              <input
                className={`inputFocus ${this.state.validState?.error?.UTGST ? "errorInput" : ""}`}
                type="number"
                id="UTGST"
                name="UTGST"
                autoComplete="off"
                value={this.state.hNSCodeDetails.UTGST}
                onChange={(event) => this.handleChange(event, "UTGST")}
              />
              {/* <ValidationText error={this.state.validState.error.UTGST} /> */}
            </div>
          </div>
          <div className="btn-grp !mt-3 mb-3.5">
            {this.state.isEditing === true ? (
              <button
                className="add-btn"
                disabled={this.state.isLoading}
                onClick={() => this.addEditHSNCode()}
              >
                {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
              </button>
            ) : (
              <button
                className="add-btn"
                disabled={this.state.isLoading}
                onClick={() => this.addEditHSNCode()}
              >
                {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
              </button>
            )}
            <button className="cancel-btn" onClick={() => this.resetForm()}
              disabled={this.state.isLoading}>
              cancel
            </button>
          </div>
          <div className="itemList-table">
            <div className="table-container" style={{ height: "calc(100vh - 255px)" }}>
              <table className="itemList">
                <thead>
                  <tr>
                    <td style={{ width: '15%' }}>HSN Code</td>
                    <td style={{ width: '35%' }}>Description</td>
                    <td style={{ width: '10%' }}>SGST</td>
                    <td style={{ width: '10%' }}>CGST</td>
                    <td style={{ width: '10%' }}>IGST</td>
                    <td style={{ width: '10%' }}>UTGST</td>
                    <td style={{ width: '10%', textAlign: 'center' }}>Action</td>
                  </tr>
                </thead>
                <tbody>
                  {this.state.hNSCodesListing &&
                    this.state.hNSCodesListing.length > 0 ?
                    this.state.hNSCodesListing.map((code, key) => (
                      <tr key={key}>
                        <td>{code.HSNCode}</td>
                        <td>{code.HNSCodeDescription}</td>
                        <td>{code.SGST}</td>
                        <td>{code.CGST}</td>
                        <td>{code.IGST}</td>
                        <td>{code.UTGST}</td>
                        <td style={{ textAlign: 'center' }}>
                          <button
                            className="search-btn"
                            onClick={() => this.getHSNCodeId(code)}
                          >
                            <FontAwesomeIcon icon={faPen} />
                          </button>
                          <button
                            className="cancel-btn"
                            onClick={() => this.deleteHSNCodeById(code._id)}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </td>
                      </tr>
                    )) : this.state.hNSCodesListing &&
                      this.state.hNSCodesListing.length === 0
                      && this.state.tableStatus !== "" ? (
                      <tr>
                        <td colSpan={7} style={{ textAlign: "center", fontSize: "16px" }}>
                          {this.state.tableStatus}
                        </td>
                      </tr>
                    ) : this.state.hNSCodesListing &&
                      this.state.hNSCodesListing.length === 0
                      && this.state.tableStatus === "" ? null : ""}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default HSNCodes;
